import React from 'react';
import {
  FiltersHorizontalWrapper,
  MultiSelectFilterPill,
  SingleSelectFilterPill,
  TextFilterPill,
} from '../../elements/Filter';

type Mentor = {
  id: number;
  name: string;
  email: string;
  topics: Array<string>;
  isCompanyMentor: boolean;
};

interface SubmissionsFiltersProps {
  statusFilter: 'All' | 'Replied' | 'Not Replied';
  setStatusFilter: (status: 'All' | 'Replied' | 'Not Replied') => void;
  mentorFilter: string[];
  setMentorFilter: (mentors: string[]) => void;
  mentors: Mentor[];
  exerciseFilter: string;
  setExerciseFilter: (exercise: string) => void;
}

const STATUS_OPTIONS = [
  { label: 'All', value: 'All' },
  { label: 'Replied', value: 'Replied' },
  { label: 'Not Replied', value: 'Not Replied' },
];

const SOSQuestionsFilters: React.FC<SubmissionsFiltersProps> = ({
  statusFilter,
  setStatusFilter,
  mentorFilter,
  setMentorFilter,
  mentors,
  exerciseFilter,
  setExerciseFilter,
}) => {
  console.log('statusFilter', statusFilter);
  return (
    <FiltersHorizontalWrapper
      style={{
        marginTop: '16px',
      }}
    >
      <SingleSelectFilterPill
        label="Status"
        value={statusFilter}
        shouldHideClear
        options={STATUS_OPTIONS}
        onChange={(value) =>
          setStatusFilter(value as 'All' | 'Replied' | 'Not Replied')
        }
      />

      <MultiSelectFilterPill
        label="Mentor"
        values={mentorFilter}
        options={mentors.map((mentor) => ({
          label: mentor.name,
          value: mentor.name,
        }))}
        onChange={setMentorFilter}
      />
      <TextFilterPill
        label="Exercise"
        value={exerciseFilter}
        onChange={setExerciseFilter}
      />
    </FiltersHorizontalWrapper>
  );
};

export default SOSQuestionsFilters;
